// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image-module--wrapper--O0I8g","image":"Image-module--image--K3FpM"};